import { render, staticRenderFns } from "./AppAuthconfig.vue?vue&type=template&id=0c1d4f88"
import script from "./AppAuthconfig.vue?vue&type=script&lang=js"
export * from "./AppAuthconfig.vue?vue&type=script&lang=js"
import style0 from "./AppAuthconfig.vue?vue&type=style&index=0&id=0c1d4f88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports